var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "crud crud-edit" }, [
    _c("form", [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-sm-8" }, [
          _c("div", { staticClass: "form-group" }, [
            _c(
              "label",
              { staticClass: "control-label", attrs: { for: "codigoVenda" } },
              [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("__.ts.codigo")) +
                    "\n                    "
                ),
              ]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.codigoVenda,
                  expression: "codigoVenda",
                },
              ],
              staticClass: "form-control",
              attrs: {
                autofocus: "",
                type: "string",
                id: "codigoVenda",
                name: "codigoVenda",
                autocomplete: "off",
              },
              domProps: { value: _vm.codigoVenda },
              on: {
                keydown: function ($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.buscarVenda($event)
                },
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.codigoVenda = $event.target.value
                },
              },
            }),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }